<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">启迪智慧，点亮未来</p>
        <p  class="font1" style="padding-top: 1.5vh;font-weight: normal;font-size: 18px;">学习带来的提升不仅是技能的精进</p>
        <p  class="font1" style="padding-top: 1vh;font-weight: normal;font-size: 18px;">更是视野的开拓</p>
        <!-- <p  class="font1" style="padding-top: 1vh;font-weight: normal;font-size: 18px;">根据您的职位状态</p> -->
        <p  class="font1" style="padding-top: 1vh;font-weight: normal;font-size: 18px;">我们精心筛选出了一些适合您的培训项目</p>
        <p  class="font1" style="padding-top: 1vh;font-weight: normal;font-size: 18px;">请勾选你感兴趣的内容</p>
        <p  class="font1" style="padding-top: 1vh;font-weight: normal;font-size: 18px;">以便及时接收课程消息</p>


        <!-- <p class="font1" style="padding-top: 3vh;margin: 0 auto; font-size: 20px;color: #000;font-weight:normal;">2025年你想参加哪些培训项目？</p> -->
        <div style="width: 70%;margin: 0 auto;margin-top: 3vh;">  
            <el-checkbox-group v-model="selectedOptions">
                <el-checkbox v-for="option in options" :key="option.value" :label="option.value" class="vertical-checkbox">
                    {{ option.label }}
                </el-checkbox>
            </el-checkbox-group>
        </div>
        <div style="text-align: center;width: 100%;margin-top: 3vh;"> 
            <button @click="submit">提交</button>
        </div>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data() {
        return {
            options: [],
            selectedOptions: [], // 存储已选择的值
        }
    }, 
    created() {
        var hongHu= JSON.parse(this.ReportData.hongHu);
        if(hongHu){
            this.options= hongHu.map((item, index) => ({
                label: item,
                value: item,
            }));
        }
    },
    methods: {
        submit() {
            if (this.selectedOptions.length === 0) {
                this.$message.error("请选择至少一个选项");
                return;
            }
            const view={
                clickCourseName:this.selectedOptions.join(','),
            }
            this.$emit('submitHongHu',view)  
        }
    }

}
</script>

<style scoped>
.body {
    background: 
                url("../../assets/logo1.png") right  top  no-repeat,
                url("../../assets/25January/icon.png") 49% calc(100% + 30px) no-repeat,
                url("../../assets/25January/bg.jpg")  no-repeat;
    background-size: 110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 92%;
    margin: 0 auto;
    padding-left: 8%;
    /* text-align: center; */
    font-size: 20px;
    color: #023047;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.vertical-checkbox {
  display: block; /* 每个选项占一行 */
  margin-bottom: 8px; /* 可选：增加间距 */
}

::v-deep(.vertical-checkbox .el-checkbox__label) {
    font-size: 17px; 
    color: #000;
}
button {
    background: #fad3ae;
    font-family: inherit;
    padding: 0.4em 1.1em;
    font-weight: 900;
    font-size: 15px;
    border: 2px solid rgb(112, 168, 200);
    border-radius: 5px;
    box-shadow: 1px 1px;
    margin:0 auto;
}

button:active {
    transform: translate(0.05em, 0.05em);
    box-shadow: 0.05em 0.05em;
}
</style>